export default "__VITE_ASSET__6ad97849__"